"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Marquee = _interopRequireDefault(require("../assets/Marquee.css"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _jsxFileName = "E:\\720\\720yun_player\\packages\\pano-marquee\\src\\Text.js";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var cx = _bind["default"].bind(_Marquee["default"]);

var Text = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Text, _React$PureComponent);

  function Text() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = Text.prototype;

  _proto.render = function render() {
    var _cx;

    var _this$props = this.props,
        fontSize = _this$props.fontSize,
        text = _this$props.text,
        maxWidth = _this$props.maxWidth,
        align = _this$props.align,
        width = _this$props.width,
        style = _this$props.style;
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: _extends({
        maxWidth: maxWidth,
        width: width,
        fontSize: fontSize
      }, style),
      className: cx('MarqueeDefault', (_cx = {}, _cx["marquee-align-" + align] = align, _cx)),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 10,
        columnNumber: 7
      }
    }, text);
  };

  return Text;
}(_react["default"].PureComponent);

var _default = Text;
exports["default"] = _default;
module.exports = exports.default;